import { useMutation } from "@tanstack/react-query";
import {
  applyDiscountCode,
  type DiscountPayload,
} from "../api/shippingService";
import { useAxiosInstance } from "./useAxiosInstance";

export const useApplyDiscountCode = () => {
  const axiosInstance = useAxiosInstance();

  return useMutation({
    mutationFn: (payload: DiscountPayload) =>
      applyDiscountCode(axiosInstance, payload),
  });
};
